import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { analyticsAction } from "@/utils/analytics";

export const periodAtom = atom(6, (_get, set, period) => {
  set(periodAtom, period);
  analyticsAction({
    action: "premium_tariff_click",
    category: "premium",
  });
});

export const optionPeriodAtom = atomFamily((options) =>
  atom(
    (get) => {
      const period = get(periodAtom);
      if (!options) return null;
      return options.find((opt) => opt.value === period);
    },
    (_get, set, { value }) => set(periodAtom, value)
  )
);
